// extracted by mini-css-extract-plugin
export default {"inputName":"styles_inputName__0sbh8","unselectable":"styles_unselectable__ftPV0","actions":"styles_actions__tdrKD","warning":"styles_warning__fqYNe","icon":"styles_icon__AMlQP"};